import SliderSlide from './SliderSlide';

export default SliderSlide;
